import React, { useState } from 'react'
import { CurrentCustomer } from '../../../integrations/allkort/graphql/interface/Customer'
import DebugInfo from '../../devtools/DebugInfo'
import Tooltip from '../../elements/Tooltip'
import { BadgeIcon, InfoIconOutlined, SettingsIcon } from '../../svgs/ExpressonSVGs'
import Link from '../Link'

type ProfileInfoProps = {
    customerData: CurrentCustomer
    mainEmail: string
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({ customerData, mainEmail }) => {
    const [showDebugInfo, setShowDebugInfo] = useState(false);
    const [badgeClickCount, setBadgeClickCount] = useState(0);

    const handleBadgeClick = () => {
        setBadgeClickCount(prev => {
            const nextCount = prev + 1;
            if (nextCount >= 20) {
                setShowDebugInfo(true);
            }
            return nextCount;
        });
    };


    return (
        <div className="profileinfo-component profile-info">
            <h5 className="profile-info__heading body-text">
                <BadgeIcon width={28} height={28} onClick={handleBadgeClick} />
                Kontoinformation
            </h5>

            <div className="profile-info__content">
                <div className="general-info">
                    <div className="item">
                        <span className="sub-heading">Identitet</span>
                    </div>

                    <div className="item">
                        <span>Namn</span>
                        <span>{customerData.name}</span>
                    </div>

                    <div className="item">
                        <span>Kundnummer</span>
                        <span>{customerData.customerNumber}</span>
                    </div>

                    <div className="item">
                        <span>E-post</span>
                        <span>{mainEmail}</span>
                    </div>

                    <div className="item address">
                        <span>Adress</span>
                        <span>
                            {customerData.address.city && customerData.address.road ? (
                                `${customerData.address.road}, ${customerData.address.city.charAt(0).toUpperCase() + customerData.address.city.slice(1).toLowerCase()}`
                            ) : (
                                'Ingen adress tillgänglig'
                            )}
                            <Tooltip position='top-end' text="Din adress uppdateras automatiskt när ändring av folkbokföringsadress görs hos Skatteverket.">
                                <InfoIconOutlined width={20} height={20} />
                            </Tooltip>
                        </span>
                    </div>
                </div>
            </div>

            {showDebugInfo && (
                <DebugInfo wrapperClasses="profile-info__debug" />
            )}

            <Link href="/mitt-konto/installningar" className="Button dashboard-button">
                <SettingsIcon width={22} height={22} />
                Hantera inställningar
            </Link>
        </div>
    )
}

export default ProfileInfo;